var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "clickable option",
      class: {
        selected: _vm.$root.shape === _vm.option.value,
        hover: _vm.hover,
      },
      attrs: { title: _vm.option.value, alt: _vm.option.value },
      on: { click: _vm.select },
    },
    [
      _c("img", { attrs: { src: _vm.option.img } }),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.option.description)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "name" }, [
        _vm._v(_vm._s(_vm.$root.shapeToDisplayName(_vm.option.value))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "info",
          attrs: { title: "info" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggle_hover.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 490 490",
              },
            },
            [
              _c("path", {
                attrs: {
                  fill: "none",
                  stroke: "#000",
                  "stroke-width": "36",
                  "stroke-linecap": "round",
                  d: "m280,278a153,153 0 1,0-2,2l170,170m-91-117 110,110-26,26-110-110",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }